module.exports = __webpack_public_path__ + "img/download.167f2d1f.svg";